/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CheckArchiveResponse
 */
export interface CheckArchiveResponse {
    /**
     * 
     * @type {boolean}
     * @memberof CheckArchiveResponse
     */
    allowed?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CheckArchiveResponse
     */
    warningCode?: CheckArchiveResponseWarningCodeEnum;
}


/**
 * @export
 */
export const CheckArchiveResponseWarningCodeEnum = {
    NewDosetiming: 'NEW_DOSETIMING',
    EcosystemUsedAnotherEntry: 'ECOSYSTEM_USED_ANOTHER_ENTRY',
    HistoryUsedAnotherEntry: 'HISTORY_USED_ANOTHER_ENTRY',
    MonitoringUsedAnotherEntry: 'MONITORING_USED_ANOTHER_ENTRY',
    BasicUsedAnotherEntry: 'BASIC_USED_ANOTHER_ENTRY'
} as const;
export type CheckArchiveResponseWarningCodeEnum = typeof CheckArchiveResponseWarningCodeEnum[keyof typeof CheckArchiveResponseWarningCodeEnum];


/**
 * Check if a given object implements the CheckArchiveResponse interface.
 */
export function instanceOfCheckArchiveResponse(value: object): value is CheckArchiveResponse {
    return true;
}

export function CheckArchiveResponseFromJSON(json: any): CheckArchiveResponse {
    return CheckArchiveResponseFromJSONTyped(json, false);
}

export function CheckArchiveResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CheckArchiveResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'allowed': json['allowed'] == null ? undefined : json['allowed'],
        'warningCode': json['warningCode'] == null ? undefined : json['warningCode'],
    };
}

export function CheckArchiveResponseToJSON(json: any): CheckArchiveResponse {
    return CheckArchiveResponseToJSONTyped(json, false);
}

export function CheckArchiveResponseToJSONTyped(value?: CheckArchiveResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'allowed': value['allowed'],
        'warningCode': value['warningCode'],
    };
}

